module.exports = "<div [hidden]=\"!loaderService.loading\" class=\"loader\">\n  <ngx-loading show=\"true\"></ngx-loading>\n</div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main